export enum ExtraCostStatus {
  INCLUDED = 'INCLUDED',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  UNKNOWN = 'UNKNOWN',
}
